import { render, staticRenderFns } from "./ClassReports.vue?vue&type=template&id=72b5f593"
import script from "./ClassReports.vue?vue&type=script&lang=js"
export * from "./ClassReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports